import { render, staticRenderFns } from "./AddResellerModal.vue?vue&type=template&id=c335ffd8&scoped=true&lang=pug&"
import script from "./AddResellerModal.vue?vue&type=script&lang=js&"
export * from "./AddResellerModal.vue?vue&type=script&lang=js&"
import style0 from "./AddResellerModal.vue?vue&type=style&index=0&id=c335ffd8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c335ffd8",
  null
  
)

export default component.exports